import { render, staticRenderFns } from "./RamoAutosComponent.vue?vue&type=template&id=5d2b1024"
import script from "./RamoAutosComponent.vue?vue&type=script&lang=js"
export * from "./RamoAutosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports